<div class="hl-shell">
  <router-outlet></router-outlet>
</div>
<app-bottom-nav></app-bottom-nav>
<app-qr-scanner-button></app-qr-scanner-button>
